/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-attribute.reducer';

export const UserAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userAttributeEntity = useAppSelector(state => state.userAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userAttribute.detail.title">UserAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.id}</dd>
          <dt>
            <span id="userId">
              <Translate contentKey="tinyMedicRestApp.userAttribute.userId">User Id</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.userId}</dd>
          <dt>
            <span id="tenantId">
              <Translate contentKey="tinyMedicRestApp.userAttribute.tenantId">Tenant Id</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.tenantId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.userAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.userAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.userAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.userAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.userAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{userAttributeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAttribute.attributeType">Attribute Type</Translate>
          </dt>
          <dd>{userAttributeEntity.attributeType ? userAttributeEntity.attributeType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAttribute.attributeEntry">Attribute Entry</Translate>
          </dt>
          <dd>{userAttributeEntity.attributeEntry ? userAttributeEntity.attributeEntry.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAttribute.tenantType">Tenant Type</Translate>
          </dt>
          <dd>{userAttributeEntity.tenantType ? userAttributeEntity.tenantType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAttribute.userType">User Type</Translate>
          </dt>
          <dd>{userAttributeEntity.userType ? userAttributeEntity.userType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-attribute/${userAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserAttributeDetail;
